<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-6" style="text-align:center">
            <h4 class="card-title no-pointer">Job Specific Rates</h4>
          </div>
          <div class="col-6">
            <div class="float-right">
              <b-button
                variant="primary"
                class="btn btn-label btn-primary"
                v-b-modal="
                  selectedTab === 'employees'
                    ? 'modal_addRate'
                    : 'modal_addProductRate'
                "
                ><i class="bx bx-plus label-icon"></i>Add Rate</b-button
              >
              <!-- Add Rate Modal -->
              <b-modal
                id="modal_addRate"
                title="Add Job Specific Rates"
                title-class="font-18"
                ok-title="Add Rates"
                size="lg"
                @ok="addRate"
                @cancel="clearEntry"
                @close="clearEntry"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <table class="table table-centered table-nowrap">
                    <thead class="thead-light" style="text-align:center">
                      <tr>
                        <th style="width: 20px;"></th>
                        <th>Name</th>
                        <th>Rate</th>
                        <th>Overtime Rate</th>
                        <th>Travel Rate</th>
                      </tr>
                    </thead>
                    <tbody style="text-align:center">
                      <tr
                        v-for="(employee, index) in employees"
                        :key="employee.uid"
                      >
                        <td>
                          <div
                            class="custom-control custom-checkbox"
                            :id="`disabled-wrapper-${index}`"
                          >
                            <input
                              :id="`customCheck${index}`"
                              type="checkbox"
                              class="custom-control-input"
                              @click="setInitialRateInputs(index, employee)"
                              :value="employee.uid"
                              v-model="checkedIDS"
                              :disabled="alreadyHasJSR(employee)"
                            />
                            <b-tooltip
                              :target="`disabled-wrapper-${index}`"
                              :disabled="!alreadyHasJSR(employee)"
                              >Employee already has rates specified for this
                              job</b-tooltip
                            >
                            <label
                              :class="
                                alreadyHasJSR(employee)
                                  ? 'disabled-checkbox'
                                  : ''
                              "
                              class="custom-control-label "
                              :for="`customCheck${index}`"
                              >&nbsp;</label
                            >
                          </div>
                        </td>
                        <td>
                          <a class="text-body font-weight-bold no-pointer">{{
                            employee.name
                          }}</a>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :class="
                              !isChecked(employee) ? 'disabled-textbox' : ''
                            "
                            :placeholder="
                              alreadyHasJSR(employee)
                                ? getCurrentRates('rate', employee.uid)
                                : ''
                            "
                            :disabled="!isChecked(employee)"
                            :state="
                              rateInput[index]
                                ? validateEntry(rateInput[index])
                                : null
                            "
                            v-model="rateInput[index]"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback">
                            Input must be a number
                          </b-form-invalid-feedback>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :class="
                              !isChecked(employee) ? 'disabled-textbox' : ''
                            "
                            :placeholder="
                              alreadyHasJSR(employee)
                                ? getCurrentRates('overtimeRate', employee.uid)
                                : ''
                            "
                            :disabled="!isChecked(employee)"
                            :state="
                              overtimeRateInput[index]
                                ? validateEntry(overtimeRateInput[index])
                                : null
                            "
                            v-model="overtimeRateInput[index]"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback">
                            Input must be a number
                          </b-form-invalid-feedback>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :class="
                              !isChecked(employee) ? 'disabled-textbox' : ''
                            "
                            :placeholder="
                              alreadyHasJSR(employee)
                                ? getCurrentRates('travelRate', employee.uid)
                                : ''
                            "
                            :disabled="!isChecked(employee)"
                            :state="
                              travelRateInput[index]
                                ? validateEntry(travelRateInput[index])
                                : null
                            "
                            v-model="travelRateInput[index]"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback">
                            Input must be a number
                          </b-form-invalid-feedback>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  :hidden="!submitErrorMessage"
                  class="badge badge-danger font-size-14 mr-2 no-pointer float-right"
                  >Please input a number for each employee selected</a
                >
              </b-modal>
              <!-- /Add Rate Modal -->
              <!--  -->
              <!--  -->
              <!-- Edit Rate Modal -->
              <b-modal
                id="modal_editRate"
                title="Edit Rates"
                title-class="font-18"
                ok-title="Submit"
                size="lg"
                @ok="editRate"
                @cancel="clearEntry"
                @close="clearEntry"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <table class="table table-centered table-nowrap">
                    <thead class="thead-light" style="text-align:center">
                      <tr>
                        <th style="width: 20px;"></th>
                        <th>Name</th>
                        <th>Rate</th>
                        <th>Overtime Rate</th>
                        <th>Travel Rate</th>
                      </tr>
                    </thead>
                    <tbody style="text-align:center">
                      <tr>
                        <td></td>
                        <td>
                          <a class="text-body font-weight-bold no-pointer">{{
                            editedUser.name
                          }}</a>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :state="
                              editedRate ? validateEntry(editedRate) : null
                            "
                            v-model="editedRate"
                          ></b-form-input>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :state="
                              editedOvertimeRate
                                ? validateEntry(editedOvertimeRate)
                                : null
                            "
                            v-model="editedOvertimeRate"
                          ></b-form-input>
                        </td>

                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :state="
                              editedTravelRate
                                ? validateEntry(editedTravelRate)
                                : null
                            "
                            v-model="editedTravelRate"
                          ></b-form-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  class="badge badge-danger font-size-14 mr-2 no-pointer float-right"
                  :hidden="!submitErrorMessage"
                  >Please input a number</a
                >
              </b-modal>
              <!-- /Edit Rate Modal -->
              <!--  -->
              <!--  -->
            </div>
          </div>
        </div>
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active @click="() => (selectedTab = 'employees')">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="bx bxs-timer"></i>
              </span>
              <span class="d-none d-sm-inline-block">Employees</span>
            </template>
            <div class="table-responsive">
              <table class="table table-centered">
                <thead style="text-align:center">
                  <tr>
                    <th></th>
                    <th></th>
                    <th>Employee</th>
                    <th>Rate</th>
                    <th>Overtime Rate</th>
                    <th>Travel Rate</th>
                  </tr>
                </thead>
                <tbody style="text-align:center">
                  <tr v-for="employee in currentEmployees" :key="employee.uid">
                    <td>
                      <b-dropdown variant="primary" size="sm">
                        <template v-slot:button-content>
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-b-modal.modal_editRate
                          @click="determineEditUser(employee.uid)"
                          ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                          >Edit</b-dropdown-item
                        >
                        <b-dropdown-item @click="removeRate(employee.uid)"
                          ><i class="bx bx-trash mr-2 tableIcons"></i
                          >Delete</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                    <td>
                      <div class="avatar-xs">
                        <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16 no-pointer"
                          >{{ employee.name.substring(0, 1) }}</span
                        >
                      </div>
                    </td>
                    <td>
                      <h5 class="font-size-16 m-0">
                        <a class="text-dark no-pointer">{{ employee.name }}</a>
                      </h5>
                    </td>
                    <td>
                      <div>
                        <a
                          class="badge badge-primary font-size-16 mr-2 no-pointer"
                        >
                          ${{ employee.rate }}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div>
                        <a
                          class="badge badge-primary font-size-16 mr-2 no-pointer"
                        >
                          ${{ employee.overtimeRate }}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div>
                        <a
                          class="badge badge-primary font-size-16 mr-2 no-pointer"
                        >
                          ${{ employee.travelRate }}
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <!--  -->
          <!--  -->
          <!--  -->
          <!--  -->
          <!-- PRODUCTS -->
          <b-tab @click="() => (selectedTab = 'products')">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="bx bxs-timer"></i>
              </span>
              <span class="d-none d-sm-inline-block">Products</span>
            </template>

            <div class="float-right">
              <!-- Add Rate Modal -->
              <b-modal
                id="modal_addProductRate"
                title="Add Job Specific Product Rates"
                title-class="font-18"
                ok-title="Add Product Rates"
                size="lg"
                @ok="addProductRate"
                @cancel="clearProductEntry"
                @close="clearProductEntry"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <table class="table table-centered table-nowrap">
                    <thead class="thead-light" style="text-align:center">
                      <tr>
                        <th style="width: 20px;"></th>
                        <th>Name</th>
                        <th>Purchase Price</th>
                        <th>Rate</th>
                      </tr>
                    </thead>
                    <tbody style="text-align:center">
                      <tr
                        v-for="(product, index) in products"
                        :key="product.uid"
                      >
                        <td>
                          <div
                            class="custom-control custom-checkbox"
                            :id="`disabled-wrapper-${index}`"
                          >
                            <input
                              :id="`customCheck${index}`"
                              type="checkbox"
                              class="custom-control-input"
                              @click="
                                setInitialProductRateInputs(index, product)
                              "
                              :value="product.uid"
                              v-model="checkedProductIDS"
                              :disabled="alreadyHasProductJSR(product)"
                            />
                            <b-tooltip
                              :target="`disabled-wrapper-${index}`"
                              :disabled="!alreadyHasProductJSR(product)"
                              >Product already has rates specified for this
                              job</b-tooltip
                            >
                            <label
                              :class="
                                alreadyHasProductJSR(product)
                                  ? 'disabled-checkbox'
                                  : ''
                              "
                              class="custom-control-label "
                              :for="`customCheck${index}`"
                              >&nbsp;</label
                            >
                          </div>
                        </td>
                        <td>
                          <a class="text-body font-weight-bold no-pointer">{{
                            product.name
                          }}</a>
                        </td>

                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :class="
                              !isProductChecked(product)
                                ? 'disabled-textbox'
                                : ''
                            "
                            :placeholder="
                              alreadyHasProductJSR(product)
                                ? getCurrentProductRates('price', product.uid)
                                : ''
                            "
                            :disabled="!isProductChecked(product)"
                            :state="
                              productPriceInput[index]
                                ? validateProductEntry(productPriceInput[index])
                                : null
                            "
                            v-model="productPriceInput[index]"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback">
                            Input must be a number
                          </b-form-invalid-feedback>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :class="
                              !isProductChecked(product)
                                ? 'disabled-textbox'
                                : ''
                            "
                            :placeholder="
                              alreadyHasProductJSR(product)
                                ? getCurrentProductRates('rate', product.uid)
                                : ''
                            "
                            :disabled="!isProductChecked(product)"
                            :state="
                              productRateInput[index]
                                ? validateProductEntry(productRateInput[index])
                                : null
                            "
                            v-model="productRateInput[index]"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback">
                            Input must be a number
                          </b-form-invalid-feedback>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  :hidden="!submitProductErrorMessage"
                  class="badge badge-danger font-size-14 mr-2 no-pointer float-right"
                  >Please input a number for each product selected</a
                >
              </b-modal>
              <!-- /Add Rate Modal -->
              <!--  -->
              <!--  -->
              <!-- Edit Rate Modal -->
              <b-modal
                id="modal_editProductRate"
                title="Edit Product Rates"
                title-class="font-18"
                ok-title="Submit"
                size="lg"
                @ok="editProductRate"
                @cancel="clearProductEntry"
                @close="clearProductEntry"
              >
                <div class="mt-4 mt-lg-0 mb-4">
                  <table class="table table-centered table-nowrap">
                    <thead class="thead-light" style="text-align:center">
                      <tr>
                        <th style="width: 20px;"></th>
                        <th>Name</th>
                        <th>Purchase Price</th>
                        <th>Rate</th>
                      </tr>
                    </thead>
                    <tbody style="text-align:center">
                      <tr>
                        <td></td>
                        <td>
                          <a class="text-body font-weight-bold no-pointer">{{
                            editedProduct.name
                          }}</a>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :state="
                              editedPrice
                                ? validateProductEntry(editedPrice)
                                : null
                            "
                            v-model="editedPrice"
                          ></b-form-input>
                        </td>
                        <td style="width:30%">
                          <b-form-input
                            style="text-align:center"
                            :state="
                              editedProductRate
                                ? validateProductEntry(editedProductRate)
                                : null
                            "
                            v-model="editedProductRate"
                          ></b-form-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a
                  class="badge badge-danger font-size-14 mr-2 no-pointer float-right"
                  :hidden="!submitProductErrorMessage"
                  >Please input a number</a
                >
              </b-modal>
              <!-- /Edit Rate Modal -->
              <!--  -->
              <!--  -->
            </div>

            <div class="table-responsive">
              <table class="table table-centered">
                <thead style="text-align:center">
                  <tr>
                    <th></th>
                    <th></th>
                    <th>Product</th>
                    <th>Purchase Price</th>
                    <th>Rate</th>
                  </tr>
                </thead>
                <tbody style="text-align:center">
                  <tr v-for="product in currentProducts" :key="product.uid">
                    <td>
                      <b-dropdown variant="primary" size="sm">
                        <template v-slot:button-content>
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-b-modal.modal_editProductRate
                          @click="determineEditProduct(product.uid)"
                          ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                          >Edit</b-dropdown-item
                        >
                        <b-dropdown-item @click="removeProductRate(product.uid)"
                          ><i class="bx bx-trash mr-2 tableIcons"></i
                          >Delete</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                    <td>
                      <div class="avatar-xs">
                        <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16 no-pointer"
                          >{{ product.name.substring(0, 1) }}</span
                        >
                      </div>
                    </td>
                    <td>
                      <h5 class="font-size-16 m-0">
                        <a class="text-dark no-pointer">{{ product.name }}</a>
                      </h5>
                    </td>
                    <td>
                      <div>
                        <a
                          class="badge badge-primary font-size-16 mr-2 no-pointer"
                        >
                          ${{ product.price }}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div>
                        <a
                          class="badge badge-primary font-size-16 mr-2 no-pointer"
                        >
                          ${{ product.rate }}
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      name: 'JobSpecificRates',
      selectedTab: 'employees',
      checkedIDS: [],
      deleteID: null,
      rateInput: [],
      overtimeRateInput: [],
      travelRateInput: [],
      editedUser: { name: 'user' },
      editedRate: null,
      editedOvertimeRate: null,
      editedTravelRate: null,
      submitErrorMessage: false,

      checkedProductIDS: [],
      deleteProductID: null,
      productRateInput: [],
      productPriceInput: [],
      editedProduct: { name: 'user' },
      editedProductRate: null,
      editedPrice: null,
      submitProductErrorMessage: false,
    };
  },
  props: {
    currentEmployees: null,
    employees: null,
    currentProducts: null,
    products: null,
    jobID: null,
    jobNum: null,
  },
  methods: {
    //*********EMPLOYEES********* */
    addRate: async function(bvModalEvt) {
      let flag = false;
      //check for valid entry
      this.rateInput.forEach((entry, index) => {
        if (this.checkedIDS.includes(this.employees[index])) {
          if (!this.validateEntry(entry)) {
            flag = true;
          }
        }
      });
      this.checkedIDS.forEach((userID) => {
        let index = this.employees.findIndex((e) => e.uid === userID);
        if (!this.rateInput[index]) {
          flag = true;
        }
      });

      this.overtimeRateInput.forEach((entry, index) => {
        if (this.checkedIDS.includes(this.employees[index])) {
          if (!this.validateEntry(entry)) {
            flag = true;
          }
        }
      });
      this.travelRateInput.forEach((entry, index) => {
        if (this.checkedIDS.includes(this.employees[index])) {
          if (!this.validateEntry(entry)) {
            flag = true;
          }
        }
      });
      this.checkedIDS.forEach((userID) => {
        let index = this.employees.findIndex((e) => e.uid === userID);
        if (!this.overtimeRateInput[index]) {
          flag = true;
        }
        if (!this.travelRateInput[index]) {
          flag = true;
        }
      });
      //if the submission does not pass the validation check, show error message and prevent modal from closing
      //else update database with all new inputs
      if (
        this.rateInput.length === 0 ||
        this.overtimeRateInput.length === 0 ||
        this.travelRateInput.length === 0 ||
        flag
      ) {
        this.submitErrorMessage = true;
        bvModalEvt.preventDefault();
      } else {
        try {
          let db = firebase.firestore();
          let page = db.collection('jobs').doc(this.jobID);

          let updatedEmployees = {};

          this.currentEmployees.forEach((employee) => {
            updatedEmployees[employee.uid] = {
              regular: employee.rate.trim(),
              overtime: employee.overtimeRate.trim(),
              travel: employee.travelRate.trim(),
            };
          });
          this.checkedIDS.forEach((userID) => {
            let index = this.employees.findIndex((e) => e.uid === userID);
            updatedEmployees[userID] = {
              regular: this.rateInput[index].trim(),
              overtime: this.overtimeRateInput[index].trim(),
              travel: this.travelRateInput[index].trim(),
            };

            this.currentEmployees.push({
              uid: userID,
              name: this.employees[index].name,
              rate: this.rateInput[index].trim(),
              overtimeRate: this.overtimeRateInput[index].trim(),
              travelRate: this.travelRateInput[index].trim(),
            });
          });

          await page
            .update({
              specifiedRates: updatedEmployees,
            })
            .then(Swal.fire('Success!', 'Rate added successfully.', 'success'))
            .catch(() => {
              console.log(`Error adding rate to job.`);
              Swal.fire(
                'Error!',
                'An error was encountered when inserting the job specific rate.',
                'error'
              );
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encounted when inserting the job specific rate.',
            'error'
          );
        }
        this.clearEntry();
      }
    },
    removeRate: async function(id) {
      let db = firebase.firestore();
      let page = db.collection('jobs').doc(this.jobID);
      let updatedEmployees = {};
      let tempIndex = -1;

      //get index of employee who's rate is to be removed, remove from array, and then update database with updated array
      try {
        this.currentEmployees.forEach(function(e, index) {
          if (e.uid === id) {
            tempIndex = index;
          } else {
            updatedEmployees[e.uid] = {
              regular: e.rate.trim(),
              overtime: e.overtimeRate.trim(),
              travel: e.travelRate.trim(),
            };
          }
        });
        if (tempIndex !== -1) {
          this.currentEmployees.splice(tempIndex, 1);
        }

        await page
          .update({
            specifiedRates: updatedEmployees,
          })
          .then(Swal.fire('Success!', 'Rate deleted successfully.', 'success'))
          .catch(() => {
            console.log(`Error deleting Rate.`);
            Swal.fire(
              'Error!',
              'An error was encountered when deleting the job specific rate.',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire(
          'Error!',
          'An error was encountered when deleting the job specific rate.',
          'error'
        );
      }
    },
    determineEditUser: function(id) {
      //determine which user to bring up in edit rate modal
      let tempIndex = -1;
      this.currentEmployees.forEach(function(e, index) {
        if (e.uid === id) {
          tempIndex = index;
        }
      });
      if (tempIndex !== -1) {
        this.editedUser = this.currentEmployees[tempIndex];
        this.editedRate = this.editedUser.rate.trim();
        this.editedOvertimeRate = this.editedUser.overtimeRate.trim();
        this.editedTravelRate = this.editedUser.travelRate.trim();
      }
    },
    editRate: async function(bvModalEvt) {
      //if the submission does not pass the validation check, show error message and prevent modal from closing
      //else update database with new input
      if (
        !this.validateEntry(this.editedRate) ||
        this.editedRate === null ||
        !this.validateEntry(this.editedOvertimeRate) ||
        this.editedOvertimeRate === null ||
        !this.validateEntry(this.editedTravelRate) ||
        this.editedTravelRate === null
      ) {
        this.submitErrorMessage = true;
        bvModalEvt.preventDefault();
      } else {
        try {
          let db = firebase.firestore();
          let page = db.collection('jobs').doc(this.jobID);
          let tempIndex = -1;

          this.currentEmployees.forEach((e, index) => {
            if (e.uid === this.editedUser.uid) {
              tempIndex = index;
            }
          });

          if (
            this.editedRate !== null &&
            this.editedOvertimeRate !== null &&
            this.editedTravelRate !== null
          ) {
            this.currentEmployees[tempIndex].rate = this.editedRate.trim();
            this.currentEmployees[
              tempIndex
            ].overtimeRate = this.editedOvertimeRate.trim();
            this.currentEmployees[
              tempIndex
            ].travelRate = this.editedTravelRate.trim();
            let updatedEmployees = {};
            this.currentEmployees.forEach((employee) => {
              updatedEmployees[employee.uid] = {
                regular: employee.rate.trim(),
                overtime: employee.overtimeRate.trim(),
                travel: employee.travelRate.trim(),
              };
            });
            await page
              .update({
                specifiedRates: updatedEmployees,
              })
              .then(
                Swal.fire('Success!', 'Rate edited successfully.', 'success')
              )
              .catch(() => {
                console.log(`Error editing rate.`);
                Swal.fire(
                  'Error!',
                  'An error was encountered when editing the job specific rate.',
                  'error'
                );
              });
          }
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the job specific rate.',
            'error'
          );
        }
        this.clearEntry();
      }
    },
    validateEntry(entry) {
      //check that value inputted is a number
      if (!isNaN(Number(entry)) && entry.trim() !== '') {
        return true;
      } else {
        return false;
      }
    },
    clearEntry() {
      this.checkedIDS = [];
      this.rateInput = [];
      this.overtimeRateInput = [];
      this.travelRateInput = [];
      this.editedUser = { name: 'user' };
      this.editedRate = null;
      this.editedOvertimeRate = null;
      this.editedTravelRate = null;
      this.submitErrorMessage = false;
    },
    isChecked: function(employee) {
      if (this.checkedIDS.includes(employee.uid)) {
        return true;
      } else {
        return false;
      }
    },
    alreadyHasJSR: function(employee) {
      return this.currentEmployees.some((e) => e.uid === employee.uid);
    },
    setInitialRateInputs(index, employee) {
      if (this.isChecked(employee)) {
        this.rateInput[index] = '';
        this.overtimeRateInput[index] = '';
        this.travelRateInput[index] = '';
      } else {
        if (!this.rateInput[index]) {
          this.rateInput[index] = this.employees[index].rate;
        }
        if (!this.overtimeRateInput[index]) {
          this.overtimeRateInput[index] = this.employees[index].overtimeRate;
        }
        if (!this.travelRateInput[index]) {
          this.travelRateInput[index] = this.employees[index].travelRate;
        }
      }
    },
    getCurrentRates(type, id) {
      let index = this.currentEmployees.findIndex(
        (employee) => employee.uid === id
      );
      return this.currentEmployees[index][type];
    },

    //*******PRODUCTS******** */
    //*********************** */
    //*********************** */
    //*********************** */
    //*********************** */

    addProductRate: async function(bvModalEvt) {
      let flag = false;
      //check for valid entry
      this.productRateInput.forEach((entry, index) => {
        if (this.checkedProductIDS.includes(this.products[index])) {
          if (!this.validateProductEntry(entry)) {
            flag = true;
          }
        }
      });
      this.checkedProductIDS.forEach((productID) => {
        let index = this.products.findIndex((e) => e.uid === productID);
        if (!this.productRateInput[index]) {
          flag = true;
        }
        if (!this.productPriceInput[index]) {
          flag = true;
        }
      });

      this.productPriceInput.forEach((entry, index) => {
        if (this.checkedProductIDS.includes(this.products[index])) {
          if (!this.validateProductEntry(entry)) {
            flag = true;
          }
        }
      });

      //if the submission does not pass the validation check, show error message and prevent modal from closing
      //else update database with all new inputs
      if (
        this.productRateInput.length === 0 ||
        this.productPriceInput.length === 0 ||
        flag
      ) {
        this.submitProductErrorMessage = true;
        bvModalEvt.preventDefault();
      } else {
        try {
          let db = firebase.firestore();
          let page = db.collection('jobs').doc(this.jobID);

          let updatedProducts = {};

          this.currentProducts.forEach((product) => {
            updatedProducts[product.uid] = {
              rate: product.rate.trim(),
              price: product.price.trim(),
            };
          });
          this.checkedProductIDS.forEach((productID) => {
            let index = this.products.findIndex((e) => e.uid === productID);
            updatedProducts[productID] = {
              rate: this.productRateInput[index].trim(),
              price: this.productPriceInput[index].trim(),
            };

            this.currentProducts.push({
              uid: productID,
              name: this.products[index].name,
              rate: this.productRateInput[index].trim(),
              price: this.productPriceInput[index].trim(),
            });
          });

          await page
            .update({
              specifiedProductRates: updatedProducts,
            })
            .then(Swal.fire('Success!', 'Rate added successfully.', 'success'))
            .catch(() => {
              console.log(`Error adding rate to job.`);
              Swal.fire(
                'Error!',
                'An error was encountered when inserting the job specific rate.',
                'error'
              );
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encounted when inserting the job specific rate.',
            'error'
          );
        }
        this.clearProductEntry();
      }
    },
    removeProductRate: async function(id) {
      let db = firebase.firestore();
      let page = db.collection('jobs').doc(this.jobID);
      let updatedProducts = {};
      let tempIndex = -1;

      //get index of employee who's rate is to be removed, remove from array, and then update database with updated array
      try {
        this.currentProducts.forEach(function(e, index) {
          if (e.uid === id) {
            tempIndex = index;
          } else {
            updatedProducts[e.uid] = {
              rate: e.rate.trim(),
              price: e.price.trim(),
            };
          }
        });
        if (tempIndex !== -1) {
          this.currentProducts.splice(tempIndex, 1);
        }

        await page
          .update({
            specifiedProductRates: updatedProducts,
          })
          .then(Swal.fire('Success!', 'Rate deleted successfully.', 'success'))
          .catch(() => {
            console.log(`Error deleting Rate.`);
            Swal.fire(
              'Error!',
              'An error was encountered when deleting the job specific rate.',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire(
          'Error!',
          'An error was encountered when deleting the job specific rate.',
          'error'
        );
      }
    },
    determineEditProduct: function(id) {
      //determine which user to bring up in edit rate modal
      let tempIndex = -1;
      this.currentProducts.forEach(function(e, index) {
        if (e.uid === id) {
          tempIndex = index;
        }
      });
      if (tempIndex !== -1) {
        this.editedProduct = this.currentProducts[tempIndex];
        this.editedProductRate = this.editedProduct.rate.trim();
        this.editedPrice = this.editedProduct.price.trim();
      }
    },
    editProductRate: async function(bvModalEvt) {
      //if the submission does not pass the validation check, show error message and prevent modal from closing
      //else update database with new input
      if (
        !this.validateEntry(this.editedProductRate) ||
        this.editedProductRate === null ||
        !this.validateEntry(this.editedPrice) ||
        this.editedPrice === null
      ) {
        this.submitProductErrorMessage = true;
        bvModalEvt.preventDefault();
      } else {
        try {
          let db = firebase.firestore();
          let page = db.collection('jobs').doc(this.jobID);
          let tempIndex = -1;

          this.currentProducts.forEach((e, index) => {
            if (e.uid === this.editedProduct.uid) {
              tempIndex = index;
            }
          });

          if (this.editedProductRate !== null && this.editedPrice !== null) {
            this.currentProducts[
              tempIndex
            ].rate = this.editedProductRate.trim();
            this.currentProducts[tempIndex].price = this.editedPrice.trim();

            let updatedProducts = {};
            this.currentProducts.forEach((product) => {
              updatedProducts[product.uid] = {
                rate: product.rate.trim(),
                price: product.price.trim(),
              };
            });
            await page
              .update({
                specifiedProductRates: updatedProducts,
              })
              .then(
                Swal.fire('Success!', 'Rate edited successfully.', 'success')
              )
              .catch(() => {
                console.log(`Error editing rate.`);
                Swal.fire(
                  'Error!',
                  'An error was encountered when editing the job specific rate.',
                  'error'
                );
              });
          }
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the job specific rate.',
            'error'
          );
        }
        this.clearProductEntry();
      }
    },
    validateProductEntry(entry) {
      //check that value inputted is a number
      if (entry !== null && !isNaN(Number(entry)) && entry.trim() !== '') {
        return true;
      } else {
        return false;
      }
    },
    clearProductEntry() {
      this.checkedProductIDS = [];
      this.productRateInput = [];
      this.productPriceInput = [];
      this.editedProduct = { name: 'product' };
      this.editedProductRate = null;
      this.editedPrice = null;
      this.submitProductErrorMessage = false;
    },
    isProductChecked: function(product) {
      if (this.checkedProductIDS.includes(product.uid)) {
        return true;
      } else {
        return false;
      }
    },
    alreadyHasProductJSR: function(product) {
      return this.currentProducts.some((e) => e.uid === product.uid);
    },
    setInitialProductRateInputs(index, product) {
      if (this.isProductChecked(product)) {
        this.productRateInput[index] = '';
        this.productPriceInput[index] = '';
      } else {
        if (!this.productRateInput[index]) {
          this.productRateInput[index] = this.products[index].rate;
        }
        if (!this.productPriceInput[index]) {
          this.productPriceInput[index] = this.products[index].price;
        }
      }
    },
    getCurrentProductRates(type, id) {
      let index = this.currentProducts.findIndex(
        (product) => product.uid === id
      );
      return this.currentProducts[index][type];
    },
  },
};
</script>
<style scoped>
.no-pointer {
  pointer-events: none;
}
.disabled-checkbox {
  cursor: not-allowed;
  opacity: 0.2;
  background-color: black !important;
}
.disabled-textbox {
  background: #e9e7e7;
}
</style>
